import {
  useActiveOrgEntry,
} from '@/hooks/context/useContextStore';
import { useIsProUser } from './useIsProUser';

/**
 * Per-org formula-recs visibility from the patient content API
 * (`entries[].showFormulaRecs`). Only applies to PRO users (partner-org
 * context). Not present on getInit v1/v2 — content API only.
 * Non-pro / consumer / no active org → always show (true).
 */
export const useShowFormulaRecs = (): boolean => {
  const isProUser = useIsProUser();
  const activeOrgEntry = useActiveOrgEntry();
  if (isProUser && activeOrgEntry) return activeOrgEntry.showFormulaRecs;
  return true;
};
